import React from 'react';
import { Close } from '@tink/core/src/components/atoms/Icons/Close';
import { Chevron } from '@tink/core/src/components/atoms/Icons/Chevron';
import { useIntl } from '@tink/core/src/components/providers/LanguageProvider/useIntl';
import { commonMessages } from '../../atoms/CommonMessages/messages';
import { StyledButton } from './HeaderButton.styles';
import { messages } from './messages';

type BackButtonProps = {
  onBack: VoidFunction | undefined;
};

type CloseButtonProps = {
  onClose: VoidFunction | undefined;
};

export const BackButton: React.FC<BackButtonProps> = ({ onBack }) => {
  const intl = useIntl();

  return (
    <StyledButton
      hidden={!onBack}
      onClick={onBack}
      data-testid="back-button"
      aria-label={intl.formatMessage(commonMessages.back)}
    >
      <Chevron color="primary" fontSize="small" direction="left" />
    </StyledButton>
  );
};

export const CloseButton: React.FC<CloseButtonProps> = ({ onClose }) => {
  const intl = useIntl();

  return (
    <StyledButton
      hidden={!onClose}
      onClick={onClose}
      data-testid="close-button"
      aria-label={intl.formatMessage(messages.close)}
      ml="auto"
    >
      <Close color="primary" fontSize="small" />
    </StyledButton>
  );
};
